import React, { useEffect, useRef, useState } from "react";

import { MediaUpload } from "../../../../Constant/api";
export default function FileUploadReturn(props) {
  const {
    Base64PDF,
    ImageUrl,
    setImageUrl,
    MediaUploadType,
    setMediaUploadType,
    hideClear,
    onSaved,
    fileName = "submitted-answer.pdf",
    ReturnPDF,
    setReturnPDF
  } = props;

  const submittedPdfBase64 = Base64PDF || ImageUrl || "";
  const pdfIframeRef = useRef(null);
  const [viewerPdfUrl, setViewerPdfUrl] = useState("");
  const [PreviewPressed, setPreviewPressed] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");
  const [ViewerLoaded, setViewerLoaded] = useState(false);
  const pdfViewerPath = `${process.env.PUBLIC_URL}/pdfjs/web/viewer.html`;

  useEffect(() => {
    return () => {
      if (viewerPdfUrl) {
        URL.revokeObjectURL(
          viewerPdfUrl
        );
      }
    };
  }, [viewerPdfUrl]);

  const cleanBase64String = (base64String) => {
    if (!base64String) {
      throw new Error(
        "Submitted PDF Base64 is empty."
      );
    }
    let cleanBase64 = String(base64String).trim();
    if (cleanBase64.startsWith("data:")) {
      const commaIndex = cleanBase64.indexOf(",");
      if (commaIndex === -1) {
        throw new Error(
          "Invalid Base64 PDF format."
        );
      }
      cleanBase64 = cleanBase64.substring(commaIndex + 1);
    }
    cleanBase64 = cleanBase64.replace(/\s/g, "");
    return cleanBase64;
  };

  const base64ToPdfBlob = (base64String) => {
    const cleanBase64 = cleanBase64String(base64String);
    let binaryString;
    try {
      binaryString = window.atob(cleanBase64);
    } catch (error) {
      console.error("Base64 decoding failed:", error);
      throw new Error(
        "The submitted PDF contains invalid Base64 data."
      );
    }

    const sliceSize = 1024 * 512;
    const byteArrays = [];
    for (let offset = 0; offset < binaryString.length; offset += sliceSize) {

      const slice = binaryString.slice(offset, offset + sliceSize);
      const byteNumbers = new Uint8Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArrays.push(byteNumbers);
    }

    const pdfBlob = new Blob(byteArrays, { type: "application/pdf" });
    return pdfBlob;
  };

  const validatePdfBlob = async (blob) => {
    if (!blob) {
      throw new Error(
        "PDF Blob was not created."
      );
    }

    if (blob.size === 0) {
      throw new Error(
        "Submitted PDF is empty."
      );
    }
    const firstBytes = await blob.slice(0, 5).text();
    console.log("PDF header:", firstBytes);
    if (!firstBytes.startsWith("%PDF")) {
      console.warn("The decoded data does not start with %PDF");
    }
  };

  const openPdfPreview = async () => {
    try {
      setLoading(true);
      setErrorMessage("");
      setViewerLoaded(false);
      if (!submittedPdfBase64) {
        throw new Error("There is no submitted PDF.");
      }
      console.log("Base64 length:", submittedPdfBase64.length);
      const pdfBlob = base64ToPdfBlob(submittedPdfBase64);
      console.log("PDF Blob:", pdfBlob);
      console.log("PDF Blob size:", pdfBlob.size);
      console.log("PDF Blob type:", pdfBlob.type);
      await validatePdfBlob(pdfBlob);
      if (viewerPdfUrl) {
        URL.revokeObjectURL(viewerPdfUrl);
      }
      const localPdfUrl = URL.createObjectURL(pdfBlob);
      console.log("Local PDF Blob URL:", localPdfUrl);
      setViewerPdfUrl(localPdfUrl);
      setPreviewPressed(true);
    } catch (error) {
      console.error("Open PDF error:", error);
      const message = error?.message || "Unable to open submitted PDF.";
      setErrorMessage(message);
      alert(message);
    } finally {
      setLoading(false);
    }
  };

  const closePdfPreview = () => {
    setPreviewPressed(false);
    setViewerLoaded(false);
    if (viewerPdfUrl) {
      URL.revokeObjectURL(viewerPdfUrl);
      setViewerPdfUrl("");
    }
  };

  const waitForPdfApplication =
    async () => {
      const maxAttempts = 100;
      const delay = 100;
      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        const iframe = pdfIframeRef.current;
        if (iframe && iframe.contentWindow) {
          const pdfApplication = iframe.contentWindow.PDFViewerApplication;
          if (pdfApplication) {
            if (pdfApplication.initializedPromise) {
              try {
                await pdfApplication.initializedPromise;
              } catch (error) {
                console.warn("PDF initializedPromise:", error);
              }
            }
            if (pdfApplication.pdfDocument) {
              return pdfApplication;
            }
          }
        }
        await new Promise(resolve => setTimeout(resolve, delay));
      }
      throw new Error("PDF.js did not finish loading the PDF.");
    };

  const getCheckedFileName = () => {
    let originalName = fileName || "submitted-answer.pdf";

    originalName = originalName.split("/").pop();
    originalName = originalName.replace(/\.pdf$/i, "");
    originalName = originalName.replace(/[^a-zA-Z0-9-_]/g, "-");
    return (originalName + "-checked-" + Date.now() + ".pdf");
  };

  const getEditedPdfFile = async () => {
    if (!pdfIframeRef.current) {
      throw new Error("PDF viewer is not available.");
    }
    const iframeWindow = pdfIframeRef.current.contentWindow;

    if (!iframeWindow) { throw new Error("Unable to access PDF.js viewer."); }

    const pdfApplication = iframeWindow.PDFViewerApplication;

    if (!pdfApplication) { throw new Error("PDF.js is not ready yet."); }

    if (pdfApplication.initializedPromise) { await pdfApplication.initializedPromise; }

    if (!pdfApplication.pdfDocument) { throw new Error("PDF document is not loaded."); }

    const annotationEditorUIManager = pdfApplication.pdfViewer?._layerProperties?.annotationEditorUIManager;
    if (annotationEditorUIManager) {
      console.log("Finishing current PDF.js drawing...");
      annotationEditorUIManager.endCurrentEditing();
    }

    await new Promise(resolve => { iframeWindow.requestAnimationFrame(() => { iframeWindow.requestAnimationFrame(resolve); }); });

    await new Promise(resolve => setTimeout(resolve, 100));

    const annotationStorage = pdfApplication.pdfDocument.annotationStorage;

    console.log("Annotation count:", annotationStorage?.size);

    if (pdfApplication.pdfScriptingManager?.dispatchWillSave) {
      await pdfApplication.pdfScriptingManager.dispatchWillSave();
    }

    let editedPdfBytes;
    try {
      editedPdfBytes = await pdfApplication.pdfDocument.saveDocument();

    } finally {
      if (pdfApplication.pdfScriptingManager?.dispatchDidSave) {
        await pdfApplication.pdfScriptingManager.dispatchDidSave();
      }
    }

    if (!editedPdfBytes || editedPdfBytes.length === 0) {
      throw new Error("PDF.js returned an empty PDF.");
    }

    console.log("Saved PDF bytes:", editedPdfBytes.length);

    const editedFile = new File([editedPdfBytes], `checked-${Date.now()}.pdf`, { type: "application/pdf", lastModified: Date.now() });
    console.log("Final edited PDF:", editedFile);
    return editedFile;
  };
  const saveCheckedPdf = async () => {
    try {
      setLoading(true);

      const editedFile =
        await getEditedPdfFile();


      /*
       * Upload to WordPress Media.
       */
      const response =
        await MediaUpload(
          editedFile
        );


      const data =
        await response.json();


      if (!response.ok) {
        throw new Error(
          data?.message ||
          "Unable to upload PDF."
        );
      }


      if (!data?.source_url) {
        throw new Error(
          "WordPress did not return source_url."
        );
      }


      console.log(
        "Uploaded checked PDF:",
        data.source_url
      );


      /*
       * return_pdf
       */
      setImageUrl(data.source_url);
      setReturnPDF(data.source_url)
      closePdfPreview()


      if (setMediaUploadType) {
        setMediaUploadType(
          "application/pdf"
        );
      }


      if (onSaved) {
        await onSaved(
          data.source_url,
          data
        );
      }


      alert(
        "Checked PDF saved successfully."
      );


    } catch (error) {

      console.error(
        "Save checked PDF error:",
        error
      );


      alert(
        error?.message ||
        "Unable to save checked PDF."
      );


    } finally {

      setLoading(false);

    }
  };

  const uploadEditedPdf = async (editedFile) => {
    console.log("Uploading checked PDF to WordPress...");
    const response = await MediaUpload(editedFile);
    const data = await response.json();
    console.log("Media upload response:", data);
    if (!response.ok) {
      throw new Error(data?.message || "Unable to upload checked PDF.");
    }
    if (!data?.source_url) {
      throw new Error("WordPress did not return source_url.");
    }
    const uploadedUrl = data.source_url;
    console.log("Uploaded checked PDF:", uploadedUrl);

    if (typeof setImageUrl === "function") {
      setImageUrl(uploadedUrl);
    }

    if (typeof setMediaUploadType === "function") {
      setMediaUploadType("application/pdf");
    }

    if (typeof onSaved === "function") {
      await onSaved(uploadedUrl, data);
    }
    return uploadedUrl;
  };


  const saveCheckedPdf2 = async () => {
    try {
      setLoading(true);
      setErrorMessage("");

      const editedFile = await getEditedPdfFile();
      const uploadedUrl = await uploadEditedPdf(editedFile);
      console.log("New return_pdf:", uploadedUrl);
      alert("Checked PDF saved successfully.");

      setReturnPDF(uploadedUrl)
      closePdfPreview();
    } catch (error) {
      console.error("Save PDF error:", error);
      const message = error?.message || "Unable to save checked PDF.";
      setErrorMessage(message);
      alert(message);
    } finally {
      setLoading(false);
    }
  };

  const saveCheckedPdf3 = async () => {
    try {
      setLoading(true);
      await new Promise(resolve => setTimeout(resolve, 250));
      const editedFile = await getEditedPdfFile();
      const response = await MediaUpload(editedFile);
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data?.message || "Unable to upload checked PDF.");
      }

      if (!data?.source_url) {
        throw new Error("WordPress did not return source_url.");
      }

      console.log("Uploaded PDF:", data.source_url);

      setImageUrl(data.source_url);
      setReturnPDF(data.source_url)
      closePdfPreview()

      if (setMediaUploadType) {
        setMediaUploadType("application/pdf");
      }

      if (onSaved) {
        await onSaved(data.source_url, data);
      }

      alert("Checked PDF saved successfully.");

    } catch (error) {
      console.error("Save error:", error);

      alert(error?.message || "Unable to save PDF.");

    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="row">
        <div className="my-2">
          <button
            type="button"
            className="sign-in-button-4"
            onClick={openPdfPreview}
            disabled={Loading || !submittedPdfBase64}
          >
            {Loading ? "Loading..." : "View / Check PDF"}
          </button>
          {!submittedPdfBase64 &&
            (
              <div style={{ marginTop: "8px", color: "#777" }}>
                No submitted PDF available.
              </div>
            )
          }

          {ErrorMessage && (
            <div style={{ marginTop: "10px", color: "red" }}>
              {ErrorMessage}
            </div>
          )
          }
        </div>
      </div>
      {PreviewPressed && viewerPdfUrl && (
        <div className="modal" style={{ display: "block", background: "rgba(0,0,0,0.6)", overflowY: "auto" }}>
          <div className="row">
            <div className="col-1" />
            <div className=" col-10" role="document" style={{ maxWidth: "none" }}>
              <div className="modal-content">
                <div className="modal-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={
                        saveCheckedPdf
                      }
                      disabled={
                        Loading ||
                        !ViewerLoaded
                      }

                    >

                      {
                        Loading
                          ? "Saving..."
                          : "Save Checked PDF"
                      }

                    </button>


                    {
                      !ViewerLoaded &&
                      (

                        <span
                          style={{
                            fontSize:
                              "13px"
                          }}
                        >

                          Loading PDF...

                        </span>

                      )
                    }


                  </div>


                  <button

                    type="button"

                    className="close"

                    aria-label="Close"

                    onClick={
                      closePdfPreview
                    }

                  >

                    <span
                      aria-hidden="true"
                    >

                      &times;

                    </span>

                  </button>


                </div>


                {/* =====================================
                      PDF.JS
                     ===================================== */}

                <div className="modal-body">


                  <iframe

                    ref={
                      pdfIframeRef
                    }

                    title="PDF Editor"

                    onLoad={() => {

                      console.log(
                        "PDF.js iframe loaded"
                      );

                      setViewerLoaded(
                        true
                      );

                    }}

                    style={{
                      width: "100%",
                      height: "82vh",
                      border: "none"
                    }}

                    src={
                      `${pdfViewerPath}?file=${encodeURIComponent(
                        viewerPdfUrl
                      )}`
                    }

                  />


                </div>


              </div>


            </div>


            <div className="col-1" />


          </div>


        </div>

      )
      }


    </div>

  );

}